import { Activity, Cpu, HardDrive, MonitorSmartphone, Zap } from "lucide-react";

const icons = [Cpu, HardDrive, Zap, MonitorSmartphone, Activity];
const getPriorityLabel = (content, index) => {
  const isZh = content.makesLabel === "产品";
  if (index === 0) return isZh ? "核心影像产品线" : "Primary Imaging Line";
  if (index === 1) return isZh ? "SSD 增长产品线" : "SSD Growth Line";
  return isZh ? "授权补充产品线" : "Authorized Support Line";
};

export function LineCard({ content, logos = [], images = [] }) {
  if (!content) return null;
  return (
    <>
      <section id="line-card" className="section linecard-section" data-testid="linecard-section">
        <div className="slide-split">
          <div className="section-heading wide">
            <p className="overline" data-testid="linecard-overline">{content.overline}</p>
            <h2 data-testid="linecard-title">{content.title}</h2>
            <p data-testid="linecard-description">{content.description}</p>
          </div>
          <div className="deck-image-panel" data-testid="linecard-image-panel-1">
            {images[0]?.image ? <img src={images[0].image} alt={content.title} data-testid="linecard-image-1" /> : <span>{content.overline}</span>}
          </div>
        </div>

        <div className="linecard-domain-strip" data-testid="linecard-domain-strip">
          {(content.partners || []).map((partner, index) => {
            const Icon = icons[index] || Cpu;
            return (
              <span key={partner.category} data-testid={`linecard-domain-${index + 1}`}>
                <Icon size={16} aria-hidden="true" /> {partner.category}
              </span>
            );
          })}
        </div>
      </section>

      <section className="section linecard-detail-section" data-testid="linecard-detail-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="linecard-detail-overline">{content.overline}</p>
          <h2 data-testid="linecard-detail-title">{content.makesLabel} / {content.appsLabel}</h2>
        </div>
        {images[1]?.image ? (
          <div className="deck-strip-image" data-testid="linecard-image-panel-2">
            <img src={images[1].image} alt={content.overline} data-testid="linecard-image-2" />
          </div>
        ) : null}
        <div className="linecard-grid" data-testid="linecard-grid">
        {(content.partners || []).map((partner, index) => {
          const Icon = icons[index] || Cpu;
          const logo = logos[index];
          return (
            <article className={`linecard-card ${index < 2 ? "featured-linecard-card" : "compact-linecard-card"}`} key={partner.name} data-testid={`linecard-partner-${index + 1}`}>
              <div className="linecard-priority" data-testid={`linecard-priority-${index + 1}`}>{getPriorityLabel(content, index)}</div>
              <div className={`linecard-logo ${logo ? "has-logo" : ""}`} data-testid={`linecard-logo-${index + 1}`}>
                {logo ? (
                  <img src={logo} alt={partner.name} data-testid={`linecard-logo-img-${index + 1}`} />
                ) : (
                  <span>{partner.name.charAt(0)}</span>
                )}
              </div>
              <div className="linecard-name">
                <strong data-testid={`linecard-name-${index + 1}`}>{partner.name}</strong>
                {partner.native ? <span data-testid={`linecard-native-${index + 1}`}>{partner.native}</span> : null}
              </div>
              <p className="card-eyebrow linecard-cat" data-testid={`linecard-category-${index + 1}`}>
                <Icon size={14} aria-hidden="true" /> {partner.category}
              </p>
              <div className="linecard-detail-rows" data-testid={`linecard-detail-rows-${index + 1}`}>
                <p className="linecard-row" data-testid={`linecard-makes-${index + 1}`}>
                  <em>{content.makesLabel}</em> <strong>{partner.makes}</strong>
                </p>
                <p className="linecard-row muted" data-testid={`linecard-apps-${index + 1}`}>
                  <em>{content.appsLabel}</em> <strong>{partner.apps}</strong>
                </p>
              </div>
            </article>
          );
        })}
        </div>
      </section>
    </>
  );
}
